/*
 * 워크숍 목록 표(tabletV 이상)의 열 너비. 머리글과 행이 같은 값을 써야 줄이 맞는다.
 * tabletV(1180px)에서는 본문이 790px 남짓이라 카테고리(진행 목록)·시간(삭제 목록)은 desktopL(1440px)부터만 보인다.
 */
export const WORKSHOP_COLUMN_CLASS = {
  check: 'flex-shrink-0 px-2',
  thumb: 'flex-shrink-0 px-2',
  date: 'flex-shrink-0 w-[90px] desktopL:w-[100px]',
  time: 'flex-shrink-0 w-[100px] desktopL:w-[120px]',
  timeDeleted: 'hidden desktopL:flex flex-shrink-0 w-[120px]',
  category: 'hidden desktopL:flex flex-shrink-0 w-[80px]',
  name: 'flex-1 min-w-[120px]',
  confirmed: 'flex-shrink-0 w-[130px] desktopL:w-[150px]',
  waitlist: 'flex-shrink-0 w-[120px] desktopL:w-[140px]',
  impact: 'flex-shrink-0 w-[130px] desktopL:w-[160px]',
  status: 'flex-shrink-0 w-[110px] desktopL:w-[130px]',
  deletedAt: 'flex-shrink-0 w-[90px] desktopL:w-[100px]',
  options: 'flex-shrink-0 w-6 px-0.5',
};
